import { OPTIONS, OPTION_VALUES } from "@ipru-common/constants/InputValues";
import { find, isArray } from "lodash";
import {
  getCurrentProductFromMeta,
  getOptionLabelInEn,
  getSelectedFunds,
  getUID,
  getPersonaTitle,
} from "@ipru-common/utils/CommonFunctions";
import { PRODUCT_DETAILS } from "@ipru-common/constants/products";
// import sha1 from "crypto-js/sha1";
import { SHA256 } from "crypto-js";
import FundsStore from "@ipru-common/store/FundsStore";
import { FundTabs } from "@ipru-common/constants/SiteConstants";
import { CurrentProduct } from "shared-library";


/**
 * Helper function to calculate age from DOB
 * @param {string} dob - Date of birth in DD/MM/YYYY format.
 * @returns {number} The calculated age.
 */
function calculateAge(dob) {
  if (!dob) return "";

  const [day, month, year] = dob.split("/");
  const formattedDOB = `${year}-${month}-${day}`;
  const birthDate = new Date(formattedDOB);
  const difference = Date.now() - birthDate.getTime();
  const ageDate = new Date(difference);

  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

function getDOB(dob) {
  if (dob) {
    const [, month, year] = dob.split("/");
    return `${month}/${year.substring(2)}`;
  }
  return "";
}

// function getPolicyType(value) {
//   let options = {
//     RP: "REGULAR",
//     LP: "LIMITED",
//     SP: "SINGLE",
//   };
//   return options[value?.slice(0, 2)];
// }

/**
 * Helper function te get sha1 encryption
 * @param {string} value
 * @returns {string}
 */

// const getSha1Encrypted = (value) => {
//   let encrypted = value || "";

//   if (typeof window !== "undefined") {
//     encrypted = sha1(value)?.toString();
//   }

//   return encrypted;
// };

const getSha256Encrypted = (value) => {
  let encrypted = value || "";

  if (typeof window !== "undefined") {
    encrypted = SHA256(value)?.toString();
  }

  return encrypted;
};

/**
 * Pushes an event to the data layer.
 * @param {DataLayer} dataLayerObj - The data object.
 */
const pushEvent = (dataLayerObj) => {
  try {
    if (window.dataLayer) {
      const data = mapToMasterData(dataLayerObj);
      console.log("---dataLayerEvent---", data);
      window.dataLayer.push(data);
    }
  } catch (error) {
    console.error("Error pushing data to dataLayer:", error);
  }
};

/**
 * Maps the data to the master data layer.
 * @param {DataLayer} data - The data object.
 * @returns {DataLayerMaster} The mapped data.
 */
const mapToMasterData = (data) => {
  const commonData = mapCommonData(data);
  const calculatorFormData = mapCalculatorFormData(data.calculatorFormData);
  const quoteFormData = mapQuoteFormData(data.calculatorFormData, data.quoteFormData);
  const appFormData = mapAppFormData(data.appFormData, data.calculatorFormData);

  // Combine all mapped form data into a single DataLayerMaster object
  return {
    ...commonData,
    ...calculatorFormData,
    ...quoteFormData,
    ...appFormData,
  };
};
const getDeviceType = () => {
  return typeof window !== "undefined" && window.innerWidth < 768 ? "Mobile" : "Desktop";
};

const getInvestStyle = (quoteFormData = {}) => {
  var selectedFunds = getSelectedFunds(quoteFormData?.allocatedFunds);

  const allocatedFunds = selectedFunds
    .map((fund) => {
      const formattedName = fund.name.toLowerCase().replace(/\s+/g, "_");
      return `${formattedName},${fund.value}%`;
    })
    .join(" | ");

  var SW =
    FundsStore.getswpExpand() === ""
      ? ""
      : FundsStore.getswpExpand() === "No"
        ? "SystematicWithdrawal_Later"
        : "SystematicWithdrawal_Now";

  var ATS =
    FundsStore.getatsExpand() === ""
      ? ""
      : FundsStore.getatsExpand() === "No"
        ? "automaticTransferStrategy_No"
        : "automaticTransferStrategy_Yes";

  var strategyLabel = FundsStore.getCurrentSelectedFundTab() || "";
  const formattedStrategyLabel = strategyLabel.toLowerCase().replace(/\s+/g, "_");

  var investStyle =
    strategyLabel === ""
      ? selectedFunds.length === 0
        ? ""
        : "Aggressive"
      : strategyLabel === FundTabs.AS_PER_YOUR_CHOICE
        ? "Aggressive"
        : "Mixed";

  return [investStyle, allocatedFunds, formattedStrategyLabel, SW, ATS].filter((value) => value !== "").join(" | ");
};
/**
 * Maps the product data to the data layer.
 * @param {DataLayer} data - The product data.
 * @returns {DataLayerMaster} The mapped data.
 */
const mapCommonData = (data) => {
  const productData = find(PRODUCT_DETAILS, { key: getCurrentProductFromMeta() });
  const eventPrefix = process.env.REACT_APP_DATALAYER_EVENT_PREFIX || ""; //discuss : no env key
  const eventName = eventPrefix + data.event;

  const calData = data.calculatorFormData;

  if (!productData) {
    return {
      event: eventName,
    };
  }

  const personaMapping = {
    smartexit: "Smart Exit",
    Limited_Pay: "Limited Pay",
    All_in_One: "All in One",
    Working_Women: "Working Women",
    monthlyincome: "Monthly Income",
    sky360: "Sky 360",
    informal: "Informal",
    employee: "Employee",
    partnerpersona: "Partner Persona",
    jointlife: "Joint Life",
    Custom_Create: "Custom Create",
    undefined: "",
  };

  const pageCategoryData = find(productData.pages, {
    pageCategory: data.currentPageCategory,
  });

  const pageSubCategory = find(productData.pages, {
    PageSubCategory: data.currentPageCategory,
  });

  const replacePersona = getPersonaTitle() ? `- ${personaMapping[getPersonaTitle()]} Persona` : "";

  return {
    event: eventName,

    ProductName: CurrentProduct?.getProductName?.() || productData.name,
    ProductCode: CurrentProduct?.getProductCode?.() || (isArray(productData.code) ? productData.code[0] : productData.code),
    SectionName: data.sectionName,

    channel: productData.channel,
    Subchannel: productData.category,
    //TODO: Add network UID using sha1
    NetworkUID1: calData.mobileno ? getSha256Encrypted(calData.mobileno) : "", // Mobile No Encrypted in SHA1
    NetworkUID2: calData.emailid ? getSha256Encrypted(calData.emailid) : "", // Email No Encrypted in SHA1
    NetworkUID3: "", //discuss
    UID: getUID(),
    UID_User: getUID(),
    Button: data.buttonText || "",
    Device: getDeviceType(),
    OptionSelected: data?.eventData?.OptionSelected || "",
    MobileNumber: data?.eventData?.MobileNumber || "",
    ScheduleCalldDate: data?.eventData?.ScheduleCalldDate || "",
    ScheduleCalldTime: data?.eventData?.ScheduleCalldTime || "",
    UserResponse: data?.eventData?.UserResponse || "",
    Question: data?.question || "",
    ...{
      ...pageCategoryData,
      pageName: pageCategoryData?.pageName?.replace("-Persona", replacePersona),
    },
    ...pageSubCategory,

    TotalCoverage: calData?.age + data?.quoteFormData?.term || "",
  };
};

/**
 * Maps the calculator form data to the data layer.
 * @param {CalculatorForm} calculatorFormData - The calculator form data.
 * @returns {DataLayerMaster} The mapped data.
 */
const mapCalculatorFormData = (calculatorFormData) => {
  return {
    UID: getUID(),
    Gender: getOptionLabelInEn(OPTIONS.GENDER, calculatorFormData.gender),
    Tobacco: getOptionLabelInEn(OPTIONS.TOBACCO_CONSUME, calculatorFormData.tobacco),
    DOB: getDOB(calculatorFormData.user_dob),
    Age: calculateAge(calculatorFormData.user_dob),
    AnnualIncome: calculatorFormData.yr_income,
    City: calculatorFormData.city || "",
    State: calculatorFormData.state || "",
    Pincode: calculatorFormData.pincode,
    Occupation: getOptionLabelInEn(
      [...OPTIONS.OCCUPATION, { id: OPTION_VALUES.OCCUPATION.HOUSEWIFE, name: "options.housewife" }],
      calculatorFormData.calc_occupation
    ),
    Education: getOptionLabelInEn(OPTIONS.EDUCATION, calculatorFormData.calc_education),
  };
};

/**
 * Maps the quote form data to the data layer.
 * @param {Object} quoteFormData - The quote form data.
 * @returns {Object} The mapped data.
 */
const mapQuoteFormData = (calculatorFormData = {}, quoteFormData = {}) => {
  return {
    Premium: quoteFormData?.invest || "",
    //need dynamic mapping as per product selected
    // Premium: quoteFormData?.invest || "",
    LifeCoverSelected: quoteFormData?.lifeCover || "",
    PaymentFrequency: quoteFormData?.paymentFrequency || "",
    PolicyTerm: quoteFormData?.term || "",
    // PolicyType: getPolicyType(quoteFormData?.paymentOption),
    PolicyType: quoteFormData?.paymentOption || "",
    PaymentTerm: (quoteFormData?.paymentOption === "RP" ? quoteFormData?.term : quoteFormData?.ppt) || "",
    PayoutOptionSelected: quoteFormData?.payoutType || "LumpSum",
    MonthlyPremium: quoteFormData?.breakupDetail?.total || "",
    YearlyPremium: quoteFormData?.breakupDetail?.annualPremium || "",
    nyPremium: quoteFormData?.breakupDetail?.total || "",
    EstimatedReturnAt4:
      (quoteFormData?.arrValue == 4 ? quoteFormData?.calculatedData?.returns?.arr[1]?.onlineReturn : "") || "",
    EstimatedReturnAt8:
      (quoteFormData?.arrValue == 8 ? quoteFormData?.calculatedData?.returns?.arr[0]?.onlineReturn : "") || "",
    CoveredAge: quoteFormData?.term + calculatorFormData?.age || "",
    ADBRValue: (quoteFormData?.adb_selected && quoteFormData?.ADB_SA) || "",
    CIValue: (quoteFormData?.ci_selected && quoteFormData?.CI_SA) || "",
    InvestStyle: getInvestStyle(quoteFormData),
    NPS_Subscriber: "",
    AnnuityFrequency: "",
    ExistingCustomer: "",
    GroupEmployee: "",
    HospitalCashBenefit: "",
    IncreasingCoverBenefit: "",
    IncomeBenefit: "",
    GoalHorizon: "",
    InsurancePortfolioHeld: "",
    RiskProfile: "",
    PolicyHolder: calculatorFormData?.relation,
    GuaranteedReturn: "",
    Savings: "",
    HomeLoan: "",
    OtherLoan: "",
    CarBrand: "",
    CarModel: "",
    CarVarient: "",
    TypeOfOwnership: "",
    AnnuityAmount: "",
    OtherInsurancePolicy: "",
    retirement: "",
    jointlifeDOB: "",
    jointlifeRelationship: "",
    Budget: "",
    hashedAppID: "",
    // EstimatedReturn: ,
    DeathBenefitOption: "",
    Step: "",
    Video: "",
    FieldEdited: "",
    Downloaded: "",
    SectionsCompleted: "",
    TypeOfPlan: "",
    Selfie: "No",
    UserRole: "BOL",
    UserVisit: "New",
    Experience: "",
    Banner: "",
  };
};

/**
 * Maps the application form data to the data layer.
 * @param {Object} appFormData - The application form data.
 * @returns {Object} The mapped data.
 */

const mapAppFormData = (appFormData = {}, calculatorFormData) => {
  const personalDetails = appFormData?.formWizard?.personalDetails || {};
  const occupationDetails = appFormData?.formWizard?.occupationDetails || {};
  const nomineeDetails = appFormData?.formWizard?.nomineeDetails || {};
  const healthDetails = appFormData?.formWizard?.healthDetails || {};

  return {
    ApplicationNumber: appFormData.appNO,

    City: calculatorFormData.city || personalDetails.city || "",
    State: calculatorFormData.state || personalDetails.state || "",
    NomineeRelationship: nomineeDetails.nominee_relationship || "",
    NomineeDOB: nomineeDetails.nominee_dob || "",
    CancerCover: healthDetails.cancerHistory || "",
    HeartCover: healthDetails.heartAilments || "",
    MaritalStatus: personalDetails.marital_status || "",
    OrganizationName: occupationDetails.organisation_name || "",
    OrganizationType: occupationDetails.organisation_type || "",
    // this values overriding calculator form values
    // AnnualIncome: occupationDetails.annual_income,
    // Occupation: occupationDetails.occupation,
  };
};

export const DataLayerService = {
  pushEvent,
};
